let place = {
  top: {
    title_1: "The location of the",
    title_2: "Rabbit VPN servers",
    explain: "We have high performance servers all over the world that can ensure your usage."
  },
  download_btn: "Download Rabbit VPN"
}
export default place


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_place/index.js